import Layout from "@/layout";

export default {
  Layout,
  'profile': () => import('@/view/profile/index.vue'),
  'dashboard-console': () => import('@/view/console/index.vue'),
  'dashboard-workspace': () => import('@/view/space/index.vue'),
  'result-success': () => import('@/view/result/success.vue'),
  'result-failure': () => import('@/view/result/failure.vue'),
  'error-403': () => import('@/view/error/403.vue'),
  'error-404': () => import('@/view/error/404.vue'),
  'error-500': () => import('@/view/error/500.vue'),
  'user': () => import('@/view/user/index.vue'),
  'role': () => import('@/view/role/index.vue'),
  'log-oper': () => import('@/view/log/oper.vue'),
  'log-auth': () => import('@/view/log/auth.vue'),
  'power': () => import('@/view/power/index.vue'),  // 权限管理
  'config': () => import('@/view/config/index.vue'),
  'dict': () => import('@/view/dict/index.vue'),
  'post': () => import('@/view/post/index.vue'),
  'dept-list': () => import('@/view/dept/index.vue'),
  'server': () => import('@/view/server/index.vue'),
  'online': () => import('@/view/online/index.vue'),
  'redis': () => import('@/view/redis/index.vue'),
  'doc': () => import('@/view/doc/index.vue'),
  'mail': () => import('@/view/mail/index.vue'),
  'oss': () => import('@/view/oss/index.vue'),
  'dept': () => import('@/view/dept/index.vue'),
  'dataSource': () => import('@/view/dataSource/index.vue'),
  'job': () => import('@/view/job/index.vue'),
  'jobLog': () => import('@/view/jobLog/index.vue'),
  'announce': () => import('@/view/announce/index.vue'),
  'inbox': () => import('@/view/inbox/index.vue'),
  'ext-contract': () => import('@/view/ext/contract/List.vue'),
  'ext-contractdetail': () => import('@/view/ext/contract/Detail.vue'),
  'ext-invitetender': () => import('@/view/ext/invitetender/List.vue'),
  'ext-invitetenderdetail': () => import('@/view/ext/invitetender/Detail.vue'),

  // 新增路由
  'meeting': () => import('@/view/meeting/index.vue'),
  'management-index': () => import('@/view/management/index.vue'),
  'meeting-before': () => import('@/view/management/meetingBefore.vue'),
  'execute': () => import('@/view/management/execute.vue'),
  'freescale': () => import('@/view/management/freescale.vue'),

  "address": () => import('@/view/moduleConfig/address.vue'),
  "risk": () => import('@/view/moduleConfig/risk.vue'),
  "watchlist": () => import('@/view/moduleConfig/watchlist.vue'),

  //会议管理
  'meetingCheck-report':()=>import('@/view/meetingCheck/report.vue'),
  'meetingCheck-list':()=>import('@/view/meetingCheck/meetingList.vue'),
  'meetingCheck-photo':()=>import('@/view/meetingCheck/photoList.vue'),
  'meetingCheck-setting':()=>import('@/view/meetingCheck/setting.vue'),
  'meetingCheck-checking':()=>import('@/view/meetingCheck/checking.vue'),

}
